import oval from "../assets/img/Oval.png"
import cheeseBurgerMax from "../assets/img/Oval Copy.png"
import lavashMax from "../assets/img/Oval Copy 2.png"
import lavashSirom from "../assets/img/Oval Copy 3.png"
import BurgerMini from "../assets/img/Oval Copy 4.png"
import CocaCola from "../assets/img/Oval Copy 5.png"
import CocaCola1 from "../assets/img/Oval Copy 7.png"
import { ReactComponent as edit } from "../assets/icon/Path.svg"
import { ReactComponent as Delete } from "../assets/icon/trash-2.svg"



const data = [
    {
        id: 1,
        Img: oval,
        foodType: "Lavash mini",
        category: "Lavash",
        cost: "5000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete
    },
    {
        id: 2,
        Img: cheeseBurgerMax,
        foodType: "CheeseBurgerMax",
        category: "Burger",
        cost: "8000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 3,
        Img: lavashMax,
        foodType: "LavashMax",
        category: "Lavash",
        cost: "7000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 4,
        Img: lavashSirom,
        foodType: "Lavash S Sirom",
        category: "Lavash",
        cost: "8500 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 5,
        Img: BurgerMini,
        foodType: "Burger mini",
        category: "Burger",
        cost: "5000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 6,
        Img: lavashSirom,
        foodType: "Lavash mini",
        category: "Lavash",
        cost: "5000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 7,
        Img: CocaCola,
        foodType: "Coca Cola 1L",
        category: "Drinks",
        cost: "3500 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 8,
        Img: BurgerMini,
        foodType: "Burger mini",
        category: "Burger",
        cost: "5000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 9,
        Img: CocaCola1,
        foodType: "Coca Cola 1.5L",
        category: "Drinks",
        cost: "5000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    }, {
        id: 10,
        Img: lavashSirom,
        foodType: "Lavash mini",
        category: "Lavash",
        cost: "5000 KRW",
        info: "Some extra info",
        editbtn: edit,
        deletebtn: Delete

    },


]
export { data }